import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminUrlAliasesNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('url-alias');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
